<template>
  <page>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-view-list</v-icon>
          <v-toolbar-title>Tariff Factor</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffFactLabel.busCls }}</v-subheader>
                <div class="queryValue">{{ tariffFactId.busCls + " - " + tariffFactId.busClsDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffFactLabel.tariff }}</v-subheader>
                <div class="queryValue">{{ tariffFactId.tariff + " - " + tariffFactId.tariffDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffFactLabel.benefit }}</v-subheader>
                <div class="queryValue">{{ tariffFactId.benefit + " - " + tariffFactId.benDesc }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffFactLabel.seqNo }}</v-subheader>
                <div class="queryValue">{{ tariffFactId.seqNo }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker v-model="filter.effDate" :label="label.effDate" :data-vv-as="label.effDate" data-vv-name="effDate"></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="filter.expDate" :label="label.expDate" :data-vv-as="label.expDate" data-vv-name="expDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew"> New Tariff Rate<v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ formatDate(row.item.effDate) }}</td>
                  <td class="text-xs-left">{{ formatDate(row.item.expDate) }}</td>
                  <td class="text-xs-left">{{ row.item.fact1 }}</td>
                  <td class="text-xs-left">{{ row.item.fact2 }}</td>
                  <td class="text-xs-left">{{ row.item.fact3 }}</td>
                  <td class="text-xs-left">{{ row.item.fact4 }}</td>
                  <td class="text-xs-left">{{ row.item.fact5 }}</td>
                  <td class="text-xs-left">{{ row.item.fact6 }}</td>
                  <td class="text-xs-left">{{ row.item.tariffRate }}</td>
                  <td class="text-xs-left">{{ row.item.minAp }}</td>
                  <td class="text-xs-left">{{ row.item.maxAp }}</td>
                  <td class="text-xs-left">{{ row.item.baseAp }}</td>
                  <td class="text-xs-left">{{ row.item.baseSi }}</td>
                  <td class="text-xs-left">{{ row.item.pctIncBaseAp }}</td>
                  <td class="text-xs-left">{{ row.item.insSi }}</td>
                  <td class="text-xs-left">{{ row.item.incApBase }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      query
                      @query="doQuery(row.item)"
                      review
                      @review="doReview(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Tariff Rate?</p>
          <div class="queryValue">
            Tariff: {{ selectedTariffRate.tariff }}<br />
            Business Class: {{ selectedTariffRate.busCls }}<br />
            Benefit: {{ selectedTariffRate.benefit }}<br />
            Sequence No.: {{ selectedTariffRate.seqNo }}<br />
            Effective Date: {{ selectedTariffRate.effDate }}<br />
            Factor 1: {{ selectedTariffRate.fact1 }}<br />
            Factor 2: {{ selectedTariffRate.fact2 }}<br />
            Factor 3: {{ selectedTariffRate.fact3 }}<br />
            Factor 4: {{ selectedTariffRate.fact4 }}<br />
            Factor 5: {{ selectedTariffRate.fact5 }}<br />
            Factor 6: {{ selectedTariffRate.fact6 }}<br />
          </div>
        </confirm>
      </v-card>
    </v-flex>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      submitting: false,
      label: {
        effDate: 'Effective Date',
        expDate: 'Expiry Date'
      },
      filter: {
        effDate: null,
        expDate: null,
        factTariff: null,
        factBenefit: null,
        factBusCls: null,
        factSeqNo: null,
        factEffDate: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Effective Date', align: 'left', value: 'effDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'Fact 1', align: 'left', value: 'fact1' },
        { text: 'Fact 2', align: 'left', value: 'fact2' },
        { text: 'Fact 3', align: 'left', value: 'fact3' },
        { text: 'Fact 4', align: 'left', value: 'fact4' },
        { text: 'Fact 5', align: 'left', value: 'fact5' },
        { text: 'Fact 6', align: 'left', value: 'fact6' },
        { text: 'Tariff Rate', align: 'left', value: 'tariffRate' },
        { text: 'Min. AP', align: 'left', value: 'minAp' },
        { text: 'Max. AP', align: 'left', value: 'maxAp' },
        { text: 'Base AP', align: 'left', value: 'baseAp' },
        { text: 'Base SI', align: 'left', value: 'baseSi' },
        { text: 'Pctlnc BaseAP', align: 'left', value: 'pctIncBaseAp' },
        { text: 'Inc. SI', align: 'left', value: 'insSi' },
        { text: 'Inc. AP', align: 'left', value: 'incApBase' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedTariffRate: {
        tariff: null,
        busCls: null,
        benefit: null,
        seqNo: null,
        effDate: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null
      },
      tariffFactLabel: {
        busCls: 'Business Class',
        tariff: 'Tariff',
        benefit: 'Benefit',
        seqNo: 'Sequence No.',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6'
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      this.fetchDesc()
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getTariffRateList
      this.filter.factTariff = this.tariffFactId.tariff
      this.filter.factBenefit = this.tariffFactId.benefit
      this.filter.factBusCls = this.tariffFactId.busCls
      this.filter.factSeqNo = this.tariffFactId.seqNo
      this.filter.factEffDate = this.tariffFactId.effDate
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)

          if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
            messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
          }

          if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
            messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
          }

          if (messageFilters.factEffDate !== null && messageFilters.factEffDate !== '') {
            messageFilters.factEffDate = formatDisplayDateTime2(removeTime(messageFilters.factEffDate))
          }

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((tariffRate) => {
                const convertList = {
                  tariff: tariffRate.tariff,
                  busCls: tariffRate.busCls,
                  benefit: tariffRate.benefit,
                  seqNo: tariffRate.seqNo,
                  effDate: tariffRate.effDate,
                  expDate: tariffRate.expDate,
                  fact1: tariffRate.fact1,
                  fact2: tariffRate.fact2,
                  fact3: tariffRate.fact3,
                  fact4: tariffRate.fact4,
                  fact5: tariffRate.fact5,
                  fact6: tariffRate.fact6,
                  tariffRate: tariffRate.tariffRate,
                  minAp: tariffRate.minAp,
                  maxAp: tariffRate.maxAp,
                  baseAp: tariffRate.baseAp,
                  baseSi: tariffRate.baseSi,
                  pctIncBaseAp: tariffRate.pctIncBaseAp,
                  insSi: tariffRate.insSi,
                  incApBase: tariffRate.incApBase
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async fetchDesc() {
      this.resetMessages()
      const apiURI = this.menu.getTariffRateListDesc
      const expand = {
        tariff: this.tariffFactId.tariff,
        busCls: this.tariffFactId.busCls,
        benefit: this.tariffFactId.benefit
      }
      if (apiURI) {
        const response = await this.$http.get(expandURI(apiURI, expand))
        const { data } = response.data
        if (data) {
          this.tariffFactId.tariffDesc = data.tariffDesc
          this.tariffFactId.busClsDesc = data.busClsDesc
          this.tariffFactId.benDesc = data.benDesc
        }
      }
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    doClearFilters() {
      this.filter.effDate = null
      this.filter.expDate = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      const commit = {
        tarfRateMode: 'New',
        tariff: this.tariffFactId.tariff,
        busCls: this.tariffFactId.busCls,
        benefit: this.tariffFactId.benefit,
        seqNo: this.tariffFactId.seqNo,
        effDate: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null
      }
      sessionStorage.setItem('tariffRate', JSON.stringify(commit))
      this.$store.commit('TARIFF_RATE_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfRateDetail' })
    },
    doReview(data) {
      const commit = {
        tarfRateMode: 'Review',
        tariff: this.tariffFactId.tariff,
        busCls: this.tariffFactId.busCls,
        benefit: this.tariffFactId.benefit,
        seqNo: this.tariffFactId.seqNo,
        effDate: data.effDate,
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      sessionStorage.setItem('tariffRate', JSON.stringify(commit))
      this.$store.commit('TARIFF_RATE_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfRateDetail' })
    },
    doQuery(data) {
      const commit = {
        tarfRateMode: 'Query',
        tariff: this.tariffFactId.tariff,
        busCls: this.tariffFactId.busCls,
        benefit: this.tariffFactId.benefit,
        seqNo: this.tariffFactId.seqNo,
        effDate: data.effDate,
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      sessionStorage.setItem('tariffRate', JSON.stringify(commit))
      this.$store.commit('TARIFF_RATE_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfRateDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteTariffRate
          const expand = {
            tariff: data.tariff,
            busCls: data.busCls,
            benefit: data.benefit,
            seqNo: data.seqNo,
            effDate: formatDisplayDateTime2(removeTime(data.effDate)),
            fact1: data.fact1,
            fact2: data.fact2,
            fact3: data.fact3,
            fact4: data.fact4,
            fact5: data.fact5,
            fact6: data.fact6
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedTariffRate.tariff = data.tariff
          this.selectedTariffRate.busCls = data.busCls
          this.selectedTariffRate.benefit = data.benefit
          this.selectedTariffRate.seqNo = data.seqNo
          this.selectedTariffRate.effDate = formatDisplayDate(data.effDate)
          this.selectedTariffRate.fact1 = data.fact1
          this.selectedTariffRate.fact2 = data.fact2
          this.selectedTariffRate.fact3 = data.fact3
          this.selectedTariffRate.fact4 = data.fact4
          this.selectedTariffRate.fact5 = data.fact5
          this.selectedTariffRate.fact6 = data.fact6

          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedTariffRate) {
        const apiURI = this.menu.deleteTariffRate
        if (apiURI) {
          const expand = {
            tariff: this.selectedTariffRate.tariff,
            busCls: this.selectedTariffRate.busCls,
            benefit: this.selectedTariffRate.benefit,
            seqNo: this.selectedTariffRate.seqNo,
            effDate: this.selectedTariffRate.effDate,
            fact1: this.selectedTariffRate.fact1,
            fact2: this.selectedTariffRate.fact2,
            fact3: this.selectedTariffRate.fact3,
            fact4: this.selectedTariffRate.fact4,
            fact5: this.selectedTariffRate.fact5,
            fact6: this.selectedTariffRate.fact6
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  async mounted() {
    this.doInit()
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('tariffFact'))
    this.$store.commit('TARIFF_FACTOR_COMMIT_KEY', jsonData)
  },
  computed: {
    menu() {
      return this.$store.state.tariffRateParam.menu
    },
    tariffFactId() {
      return this.$store.state.tariffFactorParam.tarfFact.tarfFactId
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
